import React from "react";
import { Marker } from '@react-google-maps/api';
import Pin from "../Pin";
import ShadowPin from "../ShadowPin";
import ReactDOMServer from "react-dom/server";
import { useDispatch } from "react-redux";
import { useMonitoringPin } from "../../../../hooks/useMonitoringPin";
import { SetDriverPopUp, SetOrderPinPopUp, SetOrderPinPopUpPosition, SetSelectedMonitoringDriver, SetSelectedMonitoringOrder, Table_ClearSelectedOrders, Table_DeSelectOrder, Table_SelectOrder } from "../../../../Redux/actions/actionNames";
import { GetColorByStatus } from "../../../../utils/get-colors-by-status";
import {getOrderMonitoringBounding} from "../getOrderMonitoring";
import { isPickupDelivery } from "../../side-bar/components/orderTypes";



const App = ({ position, id ,  order , key , selected}) => {
  const dispatch = useDispatch();
  let {orderIsSelected} = useMonitoringPin(order.id, order.driverId ,id)

  function OrderOnclick(event) {



    if (event.metaKey || event.ctrlKey || event.originalEvent?.metaKey || event.originalEvent?.ctrlKey || event.domEvent?.metaKey || event.domEvent?.ctrlKey) {
      if (selected) {
        dispatch(Table_DeSelectOrder(order.id))
      } else {
        dispatch(Table_SelectOrder(order))

      }

    } else {

      dispatch(Table_ClearSelectedOrders())

      dispatch(Table_SelectOrder(order))

      dispatch(SetSelectedMonitoringOrder(order.id))
           //  dispatch(SetDriverPopUp(null))
           dispatch(SetOrderPinPopUp(order))
    dispatch(SetOrderPinPopUpPosition({position:position , tag:"Dropoff2",orderId:order.id , customerId:order.customerId}))



         }
    
   }

   
        return   <Marker
        position={position}
        key={key}
        icon= {{
          anchor: selected ? { x: 14.5, y: 45.5 } : { x: 9.5, y: 34 },
          url: 'data:image/svg+xml;charset=utf-8,' +
          encodeURIComponent(ReactDOMServer.renderToStaticMarkup(<Pin selected={selected}  
          color={"#"+GetColorByStatus(order.status , order)}/>))
        }}
        onClick={OrderOnclick}
        ></Marker> 

};

export default App

